import Layout from '@/layout'

export const routerList = [
  {
    path: '/workflow',
    component: Layout,
    meta: {
      title: '审批流',
      icon: 'icon-shezhi-01'
    },
    alwaysShow: true,
    children: [
      {
        path: '/workflow/list',
        component: () => import('@/views/WorkFlow/Index'),
        name: 'WorkflowList',
        meta: { title: '审批流列表', affix: false }
      },
      {
        path: '/workflow/detail',
        component: () => import('@/views/WorkFlow/Detail'),
        name: 'WorkflowDetail',
        hidden: true,
        meta: { title: '审批流详情', affix: false }
      },
      {
        path: '/workflow/setup',
        component: () => import('@/views/WorkFlow/Setup'),
        name: 'WorkflowSetup',
        meta: { title: '审批流设置', affix: false }
      },
    ]
  }
]
